var DEFAULT_ROW_HEIGHT = 56;
var DEFAULT_HEADER_HEIGHT = 51;
var DEFAULT_NUM_SKELETON_ROWS = 1;

export { DEFAULT_NUM_SKELETON_ROWS as D, DEFAULT_ROW_HEIGHT as a, DEFAULT_HEADER_HEIGHT as b };
